import { Modal } from "react-bootstrap";
import "./QuestionnaireModalContainer.scss";
import iconClose from './../../assets/icons/icon-close.svg';
import QuestionnaireParentContainer from "../QuestionnaireParent/QuestionnaireParentContainer";

export default function QuestionnaireModal({ modalTitle, questionnaireData, questionModalStatus, toggleQuestionnaireModalStatus, onResponseSaved }:Props) {
    return (<Modal
        className='questionnaireModal'
        backdropClassName='questionnaireModalBackdrop'
        show={questionModalStatus} centered={true}
        onHide={() => toggleQuestionnaireModalStatus()}>
        <Modal.Header>
            <Modal.Title>Edit your {modalTitle?.toLowerCase()}</Modal.Title>
            <img className='close-btn' onClick={()=>toggleQuestionnaireModalStatus()} src={iconClose}
                alt='close modal' />
        </Modal.Header>

        <Modal.Body>
            <QuestionnaireParentContainer onResponseSaved={onResponseSaved} fromModal={true} fromEditProfile={true}
                questionnaireData={questionnaireData} />
        </Modal.Body>
    </Modal>);
}
